function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".gr_svg__cls-2{fill:#0c52af}"));

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#f0f0f0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "gr_svg__cls-2",
  d: "M16 2A9.94 9.94 0 006 .84V4h4V2zM19.8 8H10V6H6v4h14a10.2 10.2 0 00-.2-2zM18 4h-8v2h9.16A10 10 0 0018 4zM4 6H.84A9.92 9.92 0 000 10h4zM4 2a10.42 10.42 0 00-2 2h2zM.84 14h18.32a9.72 9.72 0 00.64-2H.2a9.72 9.72 0 00.64 2zM4 18h12a10 10 0 002-2H2a10 10 0 002 2z"
});

function SvgGr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gr_svg__Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FwYV8xIiBkYXRhLW5hbWU9IkNhcGEgMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjAgMjAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZjBmMGYwO30uY2xzLTJ7ZmlsbDojMGM1MmFmO308L3N0eWxlPjwvZGVmcz48Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9IjEwIiBjeT0iMTAiIHI9IjEwIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMTYsMkE5Ljk0LDkuOTQsMCwwLDAsNiwuODRWNGg0VjJaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMTkuOCw4SDEwVjZINnY0SDIwQTEwLjIsMTAuMiwwLDAsMCwxOS44LDhaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMTgsNEgxMFY2aDkuMTZBMTAsMTAsMCwwLDAsMTgsNFoiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik00LDZILjg0QTkuOTIsOS45MiwwLDAsMCwwLDEwSDRaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNNCwyQTEwLjQyLDEwLjQyLDAsMCwwLDIsNEg0WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTS44NCwxNEgxOS4xNmE5LjcyLDkuNzIsMCwwLDAsLjY0LTJILjJBOS43Miw5LjcyLDAsMCwwLC44NCwxNFoiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik00LDE4SDE2YTEwLDEwLDAsMCwwLDItMkgyQTEwLDEwLDAsMCwwLDQsMThaIi8+PC9zdmc+";
export { SvgGr as ReactComponent };